import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useTipoItemAquisitivo = () => {
  const [tipoItemAquisitivo, setTipoItemAquisitivo] = useState<EnumOption[]>(
    [],
  );

  useEffect(() => {
    const fetchTipoItemAquisitivo = async () => {
      try {
        const response = await httpClient.get(`/api/proaq/tipoitemaquisitivo`);

        const options = response.data.map(
          (tipoItemAquisitivo: { value: number; label: string }) => ({
            value: tipoItemAquisitivo.value.toString(),
            label: tipoItemAquisitivo.label,
          }),
        );
        setTipoItemAquisitivo(options);
      } catch (error) {
        console.error(
          'Erro ao buscar Tipo de Item do Processo Aquisitivo',
          error,
        );
      }
    };

    fetchTipoItemAquisitivo();
  }, []);

  return tipoItemAquisitivo;
};
